import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Transaction from "./pages/Transaction";
import Login from "./pages/Login";
import PrivateRoute from "./config/privateroute";
import AccessDenied from "./component/NotAcces";

export default function Root() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        
        <Route
          path="/transaction"
          element={<PrivateRoute element={<Transaction />} />}
        />
        <Route path="not-access" element={<AccessDenied />} />

      </Routes>
    </Router>
  );
}
